import React from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import { CONFIG, URL_AKM } from "../../../../config";
import akmApi from "../../../../apis/akmApi";
import accountManagement from "../../../../apis/accountManagement";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

const DropdownUploadHistoryAsync = (props) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [keterangan, setKeterangan] = React.useState("");
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      fetchUploadHistory(keterangan);
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const fetchUploadHistory = async (keterangan) => {
    await akmApi
      .post(URL_AKM.POST_UPLOAD_HISTORY_ID, {
        idAdmin: props.idAdmin,
        keterangan: keterangan,
      })
      .then((response) => {
        console.log(response.data.errorSchema.errorCode);
        if (response.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
          setOptions(response.data.data);
        } else {
          setOptions([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      style={{ width: 300 }}
      size="small"
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionSelected={(option, value) => option.keterangan === value.keterangan}
      getOptionLabel={(option) => option.keterangan}
      onChange={(event, value) => (value ? props.handleChangeUpHis(value.idUploadHistory) : props.handleChangeUpHis(""))}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cari Upload History"
          variant="outlined"
          onChange={(e) => fetchUploadHistory(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(DropdownUploadHistoryAsync);
